import { useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkGetContentList,
  trunkDeleteDocNow,
  trunkRestoreDoc,
} from "../store/admin/adminContent";

const useAdminContentStore = () => {
  const adminContentStore = useRootState((state) => state.adminContentStore);

  const dispatch = useAppDispatch();

  const boundGetContentList = useMemo(
    () => bindActionCreators(trunkGetContentList, dispatch),
    [dispatch]
  );
  const boundDeleteDocNow = useMemo(
    () => bindActionCreators(trunkDeleteDocNow, dispatch),
    [dispatch]
  );
  const boundRestoreDoc = useMemo(
    () => bindActionCreators(trunkRestoreDoc, dispatch),
    [dispatch]
  );

  return {
    adminContentStore,
    getContentList: boundGetContentList,
    deleteDocNow: boundDeleteDocNow,
    restoreDoc: boundRestoreDoc,
  };
};

export default useAdminContentStore;
